import { Component, EventEmitter, Output, OnInit  } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs/internal/Subscription';
import {
  NotificationSeverity,
  NotifyService,
  HttpService,
  AuthService,
  TokenService
} from 'src/app/services';
import { environment as env } from 'src/environments/environment';

@Component({
  selector: 'cm-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent {

  @Output() close: EventEmitter<void> = new EventEmitter();

  protected frmChgPw: FormGroup;

  constructor(
    private fb: FormBuilder,
    private translate: TranslateService,
    private notification: NotifyService,
    private http: HttpService,
    private auth: AuthService,
    private token: TokenService,
  ) {
    this.frmChgPw = this.fb.group({
      oldPassword: new FormControl('', Validators.required),
      newPassword: new FormControl('', Validators.required),
      confirmPassword: new FormControl('', Validators.required),
    });
  }

  onClose(): void {
    this.close.emit();
  }

  changeNow() {
    const isValid = this.changePwValidation();
    if (!isValid || !this.frmChgPw.valid) {
      this.oldPassword!.markAllAsTouched();
      this.newPassword!.markAllAsTouched();
      this.confirmPassword!.markAllAsTouched();
      return;
    }

    var title = '';
    var message = '';

    // const userProfile = this.auth.getUserProfile();

    const payload: any = {
      CurrentCulture: this.token.getLocalToken(env.TokenKeys.LanguageToken),
      // AcctUserId: userProfile.AcctUserId,
      // AcctId: userProfile.AcctId,
      OldPassword: this.auth.createHash256(this.oldPassword!.value),
      NewPassword: this.auth.createHash256(this.newPassword!.value),
      IsBackendReset: true,
      // IpAddress: userProfile.IpAddress,
      UserRoleId: 0,
      LoggedInAcctUserId: "",
      UserAgent: null,
      Country: null,
    }

    this.http.post('account', 'resetpassword', payload)
      .subscribe((resp) => {
        if (resp && resp.Code == 1) {
          this.translate.get('accounts.password.title').subscribe((text: string) => {title = text;});
          this.translate.get('accounts.password.update_success').subscribe((text: string) => {message = text;});

          this.notification.displayNotification(
            title ,
            message,
            NotificationSeverity.Success
          );

          this.onClose();
        } else {
          this.translate.get('accounts.password.title').subscribe((text: string) => {title = text;});
          this.translate.get('accounts.password.update_fail').subscribe((text: string) => {message = text;});

          this.notification.displayNotification(
            title ,
            message,
            NotificationSeverity.Error
          );
        }
      });
  }

  changePwValidation() {
    var title = 'Change Password';
    this.translate
      .get('accounts.password.title')
      .subscribe((text: string) => {
        title = text;
      });

    let old_password, new_password, confirm_password;
    let message = '';
    [old_password, new_password, confirm_password] = [
      this.oldPassword!.value,
      this.newPassword!.value,
      this.confirmPassword!.value
    ];

    if (!old_password) {
      this.translate
        .get('accounts.password.invalid_old_password')
        .subscribe((text: string) => {
          message = text;
        });
      this.displayNotification(title, message);
      return false;
    }

    if (!new_password) {
      this.translate
        .get('accounts.password.invalid_new_password')
        .subscribe((text: string) => {
          message = text;
        });
      this.displayNotification(title, message);
      return false;
    } else if (new_password.length < 6 || new_password.length > 14) {
      this.translate
        .get('accounts.password.invalid_new_password_length')
        .subscribe((text: string) => {
          message = text;
        });
      this.displayNotification(title, message);
      return false;
    }

    if (!confirm_password || new_password != confirm_password) {
      this.translate
        .get('accounts.password.password_does_not_match')
        .subscribe((text: string) => {
          message = text;
        });
      this.displayNotification(title, message);
      return false;
    }

    return true;
  }

  private displayNotification(title: string, message: string): void {
    this.notification.displayNotification(
      title,
      message,
      NotificationSeverity.Error
    );
  }

  get oldPassword() {
    return this.frmChgPw.get('oldPassword');
  }

  get newPassword() {
    return this.frmChgPw.get('newPassword');
  }

  get confirmPassword() {
    return this.frmChgPw.get('confirmPassword');
  }
}
